/* ============================================================
   PACK CONFIGURATOR · arquitectura pack-driven
   Sylaris · v4 · auto-load + single-option steps
   ============================================================ */

(function () {
  'use strict';

  console.log('%c[PackConfigurator] script loaded · v10 · auto-advance', 'color:#8b3a2e;font-weight:bold');

  const root = document.querySelector('[data-configurator]');
  if (!root) return;

  const payloadEl = root.parentElement.querySelector('[data-cfg-payload]')
    || document.querySelector('[data-cfg-payload]');
  if (!payloadEl) {
    console.warn('[PackConfigurator] No payload.');
    return;
  }

  let DATA = {};
  try {
    DATA = JSON.parse(payloadEl.textContent);
  } catch (e) {
    console.error('[PackConfigurator] Payload JSON parse error:', e);
    return;
  }

  const packBtns = root.querySelectorAll('[data-pack]');
  const hint = root.querySelector('[data-cfg-hint]');
  const mount = root.querySelector('[data-cfg-active]');
  const autoloadHandle = root.dataset.cfgAutoload || null;

  const STATE = {
    pack: null,
    selections: {},
  };

  /* Step de una sola opción obligatoria · se auto-selecciona y muestra como info */
  function isSingleOption(step) {
    return step
      && step.products
      && step.products.length === 1
      && Number(step.min) >= 1
      && Number(step.max) <= 1;
  }

  /* Auto-selecciona los single-option steps de un pack (solo si disponible) */
  function autoSelectSingles(pack) {
    if (!pack || !pack.steps) return;
    for (const step of pack.steps) {
      if (isSingleOption(step) && !(STATE.selections[step.id] || []).length) {
        const only = step.products[0];
        if (only && only.available !== false) {
          STATE.selections[step.id] = [only.handle];
        }
      }
    }
  }

  /* ============ Helpers ============ */
  function getPack(handle) {
    return DATA.packs && DATA.packs.find(p => p.handle === handle);
  }

  function formatPrice(n) {
    return Number(n).toFixed(2).replace('.', ',') + ' €';
  }

  function escapeHtml(s) {
    const d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function calcTotalSurcharge(pack) {
    let total = 0;
    for (const step of pack.steps) {
      const sel = STATE.selections[step.id] || [];
      for (const handle of sel) {
        const p = step.products.find(prod => prod.handle === handle);
        if (p && p.surcharge) total += Number(p.surcharge);
      }
    }
    return total;
  }

  function allMinsMet(pack) {
    return pack.steps.every(s => (STATE.selections[s.id] || []).length >= s.min);
  }

  /* ============ Render · bloque activo ============ */
  function renderActiveBlock(pack) {
    return `
      <div class="cfg-active">
        <div class="cfg-active-chip">Configurando · ${escapeHtml(pack.name)} · ${pack.price} €</div>
        <h2 class="cfg-active__title">Diseña tu <em>${escapeHtml(pack.name)}</em>.</h2>

        <div class="cfg-active__grid">
          <div class="cfg-steps">
            ${pack.steps && pack.steps.length
              ? pack.steps.map((step, i) => renderStep(step, i)).join('')
              : `<p class="cfg-empty">Este pack no tiene pasos configurados. Edita el producto en admin y añade pasos al metafield <code>pack.steps</code>.</p>`}
          </div>
          <aside class="cfg-summary">
            ${renderSummary(pack)}
          </aside>
        </div>
      </div>
      ${renderMobileBar(pack)}
    `;
  }

  function renderMobileBar(pack) {
    const totalSurcharge = calcTotalSurcharge(pack);
    const finalTotal = Number(pack.price) + totalSurcharge;
    const minsMet = allMinsMet(pack);
    const requiredSteps = pack.steps.filter(s => s.min > 0);
    const minsMetCount = requiredSteps.filter(s => (STATE.selections[s.id] || []).length >= s.min).length;
    const isDisabled = pack.disabled === true;
    const disabledLabel = DATA.disabled_cta || 'Próximamente';

    let cta;
    if (isDisabled) {
      cta = `<button type="button" class="cfg-mbar__cta cfg-mbar__cta--disabled" disabled>${escapeHtml(disabledLabel)}</button>`;
    } else if (minsMet) {
      cta = `<button type="button" class="cfg-mbar__cta" data-cfg-mbar-add>Añadir</button>`;
    } else {
      cta = `<button type="button" class="cfg-mbar__cta" disabled>Faltan ${requiredSteps.length - minsMetCount}</button>`;
    }

    return `
      <div class="cfg-mbar" data-cfg-mbar>
        <div class="cfg-mbar__info">
          <span class="cfg-mbar__name">Pack <em>${escapeHtml(pack.name)}</em></span>
          <span class="cfg-mbar__progress">${minsMetCount}/${requiredSteps.length} pasos · ${Math.round(finalTotal)}€</span>
        </div>
        ${cta}
      </div>
    `;
  }

  function renderStep(step, idx) {
    const selected = STATE.selections[step.id] || [];

    /* Caso single-option · tarjeta informativa, no selector */
    if (isSingleOption(step)) {
      const p = step.products[0];
      const hasImg = p.image && p.image !== '';
      const sDelay = 120 + idx * 90;
      return `
        <div class="cfg-step cfg-step--single" data-step="${escapeHtml(step.id)}" data-cfg-reveal data-cfg-reveal-delay="${sDelay}">
          <div class="cfg-step__head">
            <span class="cfg-step__num">${idx + 1}</span>
            <div class="cfg-step__heads">
              <h3 class="cfg-step__title">${step.title}</h3>
              <p class="cfg-step__subtitle">${escapeHtml(step.subtitle)}</p>
            </div>
            <span class="cfg-step__count cfg-step__count--ok">Incluido</span>
          </div>
          <div class="cfg-single">
            <div class="cfg-single__img">
              ${hasImg
                ? `<img src="${escapeHtml(p.image)}" alt="${escapeHtml(p.title)}" loading="lazy">`
                : `<div class="cfg-product__noimg">${escapeHtml(p.title.slice(0,2).toUpperCase())}</div>`}
            </div>
            <div class="cfg-single__info">
              <div class="cfg-single__name">${escapeHtml(p.title)}</div>
              ${p.description ? `<p class="cfg-single__desc">${escapeHtml(p.description.slice(0, 180))}${p.description.length > 180 ? '…' : ''}</p>` : ''}
              <button type="button" class="cfg-single__more" data-info-handle="${escapeHtml(p.handle)}" data-info-step="${escapeHtml(step.id)}">Ver más</button>
            </div>
          </div>
        </div>
      `;
    }

    const ruleLabel = step.min === 0
      ? `Opcional · hasta ${step.max}`
      : step.max > step.min
        ? `${step.min} a ${step.max}`
        : `Elige ${step.max}`;

    /* Ordenar:
       1. Disponibles primero, agotadas al final
       2. Mismo producto base agrupado (por product_handle)
       3. Variantes ordenadas por sus opciones (primera, luego segunda, etc.)
       Para mantener orden estable cuando todo lo demás es igual, fallback a índice original */
    const sortedProducts = (step.products || []).map((p, i) => ({ p, i })).sort((A, B) => {
      const a = A.p, b = B.p;
      const aOut = a.available === false ? 1 : 0;
      const bOut = b.available === false ? 1 : 0;
      if (aOut !== bOut) return aOut - bOut;
      const ah = a.product_handle || a.handle;
      const bh = b.product_handle || b.handle;
      if (ah !== bh) return A.i - B.i; // productos distintos: orden de entrada
      // Mismo producto, comparar opciones
      const oa = a.options || [];
      const ob = b.options || [];
      const len = Math.max(oa.length, ob.length);
      for (let k = 0; k < len; k++) {
        const va = (oa[k] || '').toString();
        const vb = (ob[k] || '').toString();
        if (va !== vb) return va.localeCompare(vb, 'es', { sensitivity: 'base', numeric: true });
      }
      return A.i - B.i;
    }).map(x => x.p);

    const productsHtml = sortedProducts.length
      ? sortedProducts.map(p => renderProduct(p, step.id, selected)).join('')
      : `<p class="cfg-empty">Esta categoría no tiene productos. Añade productos a la colección desde el admin.</p>`;

    const delay = 120 + idx * 90;
    return `
      <div class="cfg-step" data-step="${escapeHtml(step.id)}" data-cfg-reveal data-cfg-reveal-delay="${delay}">
        <div class="cfg-step__head">
          <span class="cfg-step__num">${idx + 1}</span>
          <div class="cfg-step__heads">
            <h3 class="cfg-step__title">${step.title}</h3>
            <p class="cfg-step__subtitle">${escapeHtml(step.subtitle)}</p>
          </div>
          <span class="cfg-step__count">${selected.length}/${step.max} · ${ruleLabel}</span>
        </div>
        <div class="cfg-products">
          ${productsHtml}
        </div>
      </div>
    `;
  }

  /* Devuelve el "nombre visible" de un producto+variante:
     - sin opciones: solo product_title
     - con opciones: product_title + primera opción */
  function visibleName(p) {
    if (p.options && p.options.length > 0) {
      return (p.product_title || p.title) + ' ' + p.options[0];
    }
    return p.product_title || p.title;
  }

  /* Meta secundaria (opciones 2 a N), separadas por · */
  function variantMeta(p) {
    if (!p.options || p.options.length <= 1) return '';
    return p.options.slice(1).join(' · ');
  }

  /* Etiqueta completa para cart properties: producto + todas las opciones */
  function fullVariantLabel(p) {
    if (p.options && p.options.length > 0) {
      return (p.product_title || p.title) + ' ' + p.options.join(' · ');
    }
    return p.product_title || p.title;
  }

  function renderProduct(p, stepId, selected) {
    const isSel = selected.includes(p.handle);
    const hasImg = p.image && p.image !== '';
    const isSoldout = p.available === false;
    const surchargeHtml = p.surcharge > 0
      ? `<div class="cfg-product__surcharge">+${formatPrice(p.surcharge)}</div>`
      : '';
    const soldoutBadge = isSoldout
      ? `<span class="cfg-product__soldout">Agotado</span>`
      : '';
    const cls = ['cfg-product'];
    if (isSel) cls.push('is-selected');
    if (isSoldout) cls.push('is-soldout');

    const name = visibleName(p);
    const meta = variantMeta(p);
    const metaHtml = meta ? `<div class="cfg-product__meta">${escapeHtml(meta)}</div>` : '';

    return `
      <article class="${cls.join(' ')}" data-handle="${escapeHtml(p.handle)}" data-step="${escapeHtml(stepId)}" ${isSoldout ? 'aria-disabled="true"' : ''}>
        <button type="button" class="cfg-product__info" data-info-handle="${escapeHtml(p.handle)}" data-info-step="${escapeHtml(stepId)}" aria-label="Ver más sobre ${escapeHtml(name)}">i</button>
        <div class="cfg-product__img">
          ${hasImg
            ? `<img src="${escapeHtml(p.image)}" alt="${escapeHtml(name)}" loading="lazy">`
            : `<div class="cfg-product__noimg">${escapeHtml(name.slice(0,2).toUpperCase())}</div>`}
          <div class="cfg-product__check">✓</div>
          ${soldoutBadge}
        </div>
        <div class="cfg-product__name">${escapeHtml(name)}</div>
        ${metaHtml}
        ${surchargeHtml}
      </article>
    `;
  }

  /* ============ Modal · Ver más info de producto ============ */
  let modalEl = null;
  let modalState = { handle: null, stepId: null, index: 0 };

  function ensureModal() {
    if (modalEl) return modalEl;
    modalEl = document.createElement('div');
    modalEl.className = 'cfg-modal';
    modalEl.setAttribute('hidden', '');
    modalEl.innerHTML = '<div class="cfg-modal__overlay" data-cfg-modal-close></div><div class="cfg-modal__content" role="dialog" aria-modal="true"></div>';
    document.body.appendChild(modalEl);
    modalEl.addEventListener('click', e => {
      if (e.target.matches('[data-cfg-modal-close]')) closeModal();
      if (e.target.matches('[data-cfg-modal-prev]')) galleryStep(-1);
      if (e.target.matches('[data-cfg-modal-next]')) galleryStep(1);
      if (e.target.matches('[data-cfg-modal-thumb]')) {
        modalState.index = Number(e.target.dataset.cfgModalThumb);
        renderModal();
      }
      if (e.target.matches('[data-cfg-modal-select]')) {
        toggleProduct(modalState.stepId, modalState.handle);
        closeModal();
      }
    });
    document.addEventListener('keydown', e => {
      if (modalEl.hasAttribute('hidden')) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft') galleryStep(-1);
      if (e.key === 'ArrowRight') galleryStep(1);
    });
    return modalEl;
  }

  function openInfo(stepId, handle) {
    const pack = getPack(STATE.pack);
    if (!pack) return;
    const step = pack.steps.find(s => s.id === stepId);
    if (!step) return;
    const p = step.products.find(prod => prod.handle === handle);
    if (!p) return;
    modalState = { handle, stepId, index: 0, product: p };
    ensureModal();
    renderModal();
    modalEl.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!modalEl) return;
    modalEl.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  function galleryStep(dir) {
    const p = modalState.product;
    if (!p || !p.images || p.images.length === 0) return;
    const n = p.images.length;
    modalState.index = (modalState.index + dir + n) % n;
    renderModal();
  }

  function renderModal() {
    const p = modalState.product;
    if (!p) return;
    const images = (p.images && p.images.length) ? p.images : (p.image ? [p.image] : []);
    const idx = Math.min(modalState.index, Math.max(0, images.length - 1));
    const hasMulti = images.length > 1;
    const isSel = (STATE.selections[modalState.stepId] || []).includes(p.handle);
    const surchargeBadge = p.surcharge > 0
      ? `<span class="cfg-modal__surcharge">Suplemento +${formatPrice(p.surcharge)}</span>`
      : '';

    const galleryHtml = images.length
      ? `<div class="cfg-modal__gallery">
           <img src="${escapeHtml(images[idx])}" alt="${escapeHtml(p.title)}">
           ${hasMulti ? `
             <button type="button" class="cfg-modal__nav cfg-modal__nav--prev" data-cfg-modal-prev aria-label="Anterior">‹</button>
             <button type="button" class="cfg-modal__nav cfg-modal__nav--next" data-cfg-modal-next aria-label="Siguiente">›</button>
             <div class="cfg-modal__counter">${idx + 1} / ${images.length}</div>
           ` : ''}
         </div>
         ${hasMulti ? `<div class="cfg-modal__thumbs">
           ${images.map((src, i) => `<button type="button" class="cfg-modal__thumb ${i === idx ? 'is-active' : ''}" data-cfg-modal-thumb="${i}" aria-label="Imagen ${i + 1}"><img src="${escapeHtml(src)}" alt=""></button>`).join('')}
         </div>` : ''}`
      : `<div class="cfg-modal__gallery cfg-modal__gallery--empty">Sin imagen</div>`;

    modalEl.querySelector('.cfg-modal__content').innerHTML = `
      <button type="button" class="cfg-modal__close" data-cfg-modal-close aria-label="Cerrar">✕</button>
      ${galleryHtml}
      <div class="cfg-modal__info">
        <h3 class="cfg-modal__title">${escapeHtml(p.title)}</h3>
        ${surchargeBadge}
        <p class="cfg-modal__desc">${p.description ? escapeHtml(p.description) : '<em>Sin descripción disponible.</em>'}</p>
        <div class="cfg-modal__actions">
          <button type="button" class="cfg-modal__cta ${isSel ? 'is-sel' : ''}" data-cfg-modal-select>${isSel ? 'Quitar de mi pack' : 'Añadir a mi pack'}</button>
        </div>
      </div>
    `;
  }

  /* ============ Summary ============ */
  function renderSummary(pack) {
    const totalSurcharge = calcTotalSurcharge(pack);
    const finalTotal = Number(pack.price) + totalSurcharge;
    const minsMet = allMinsMet(pack);
    const requiredSteps = pack.steps.filter(s => s.min > 0);
    const minsMetCount = requiredSteps.filter(s => (STATE.selections[s.id] || []).length >= s.min).length;
    const isDisabled = pack.disabled === true;
    const disabledLabel = DATA.disabled_cta || 'Próximamente';

    let ctaHtml;
    if (isDisabled) {
      ctaHtml = `<button type="button" class="cfg-summary__cta cfg-summary__cta--disabled" disabled aria-disabled="true">${escapeHtml(disabledLabel)}</button>`;
    } else if (minsMet) {
      ctaHtml = `<button type="button" class="cfg-summary__cta" data-cfg-add>Añadir al carrito</button>`;
    } else {
      ctaHtml = `<button type="button" class="cfg-summary__cta" disabled>Faltan pasos</button>`;
    }

    return `
      <div class="cfg-summary__inner">
        <div class="cfg-summary__label">Tu pack ahora</div>
        <h4 class="cfg-summary__name">Pack <em>${escapeHtml(pack.name)}</em></h4>
        ${isDisabled
          ? `<p class="cfg-summary__notice">Este pack todavía no está disponible. Puedes explorarlo, pero aún no se puede comprar.</p>`
          : `<p class="cfg-summary__progress">${minsMetCount} de ${requiredSteps.length} pasos obligatorios completados</p>`
        }

        <ul class="cfg-summary__items">
          ${renderSummaryItems(pack)}
        </ul>

        <div class="cfg-summary__totals">
          ${totalSurcharge > 0 ? `
            <div class="cfg-summary__row cfg-summary__row--small">
              <span>Precio base</span>
              <span>${formatPrice(pack.price)}</span>
            </div>
            <div class="cfg-summary__row cfg-summary__row--small">
              <span>Suplementos</span>
              <span>+${formatPrice(totalSurcharge)}</span>
            </div>
          ` : ''}
          <div class="cfg-summary__row cfg-summary__row--total">
            <span class="cfg-summary__totalLbl">Total pack</span>
            <span class="cfg-summary__totalVal">${Math.round(finalTotal)}<small>€</small></span>
          </div>
        </div>

        ${ctaHtml}
      </div>
    `;
  }

  function renderSummaryItems(pack) {
    const lines = [];
    pack.steps.forEach(step => {
      const sel = STATE.selections[step.id] || [];
      const stepLabel = (step.title || '').replace(/<\/?em>/g, '');

      // Caso 1: sin selección · placeholder (siempre se renderiza)
      if (sel.length === 0) {
        const txt = step.min === 0 ? 'opcional' : 'pendiente';
        lines.push(`
          <li class="cfg-summary__item cfg-summary__item--empty">
            <span class="cfg-summary__itemImg cfg-summary__itemImg--placeholder" aria-hidden="true"></span>
            <span class="cfg-summary__itemLab">${escapeHtml(stepLabel)}<small>${txt}</small></span>
            <span class="cfg-summary__itemPr">—</span>
          </li>`);
        return;
      }

      // Caso 2: hay selección · una línea por handle elegido
      sel.forEach(handle => {
        const p = step.products.find(prod => prod.handle === handle);
        // Fallback: si por lo que sea no encontramos el producto, mostramos handle crudo
        const title = p ? fullVariantLabel(p) : handle;
        const surcharge = p ? Number(p.surcharge || 0) : 0;
        const priceCell = surcharge > 0
          ? `<span class="cfg-summary__itemPr cfg-summary__itemPr--surcharge">+${formatPrice(surcharge)}</span>`
          : `<span class="cfg-summary__itemPr cfg-summary__itemPr--included">incluido</span>`;
        const imgHtml = p && p.image
          ? `<img class="cfg-summary__itemImg" src="${escapeHtml(p.image)}" alt="" loading="lazy">`
          : `<span class="cfg-summary__itemImg cfg-summary__itemImg--noimg" aria-hidden="true">${escapeHtml((p && p.product_title ? p.product_title : title).slice(0, 1).toUpperCase())}</span>`;
        lines.push(`
          <li class="cfg-summary__item">
            ${imgHtml}
            <span class="cfg-summary__itemLab">${escapeHtml(stepLabel)}<small>${escapeHtml(title)}</small></span>
            ${priceCell}
          </li>`);
      });
    });
    return lines.join('');
  }

  /* ============ Acciones ============ */
  function setPack(handle, opts) {
    opts = opts || {};
    if (STATE.pack === handle) return;
    STATE.pack = handle;
    STATE.selections = {};

    /* Auto-seleccionar los steps de una sola opción obligatoria */
    const pack = getPack(handle);
    if (pack) autoSelectSingles(pack);

    packBtns.forEach(btn => btn.classList.toggle('is-active', btn.dataset.pack === handle));
    if (hint) hint.classList.add('is-hidden');

    renderMount();

    if (!opts.silent) {
      setTimeout(() => {
        const active = root.querySelector('.cfg-active');
        if (active) active.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    }
  }

  function toggleProduct(stepId, handle) {
    console.log('%c[toggleProduct]', 'color:#8b3a2e', 'stepId:', stepId, '· handle:', handle, '· STATE antes:', JSON.parse(JSON.stringify(STATE.selections)));
    const pack = getPack(STATE.pack);
    if (!pack) return;
    const step = pack.steps.find(s => s.id === stepId);
    if (!step) { console.warn('[toggleProduct] step NO encontrado en pack.steps:', stepId, 'available:', pack.steps.map(s => s.id)); return; }

    /* Bloqueo si variante agotada */
    const prod = step.products.find(pp => pp.handle === handle);
    if (prod && prod.available === false) {
      console.log('[toggleProduct] producto agotado, ignorado:', handle);
      return;
    }

    const sel = STATE.selections[stepId] || [];
    const wasDeselection = sel.includes(handle);

    if (wasDeselection) {
      STATE.selections[stepId] = sel.filter(h => h !== handle);
    } else {
      if (sel.length >= step.max) {
        if (step.max === 1) STATE.selections[stepId] = [handle];
        else STATE.selections[stepId] = [...sel.slice(1), handle];
      } else {
        STATE.selections[stepId] = [...sel, handle];
      }
    }
    console.log('%c[toggleProduct] STATE después:', 'color:#8b3a2e', JSON.parse(JSON.stringify(STATE.selections)));
    renderMount();
    maybeAutoAdvance(stepId, step, wasDeselection);
  }

  /* Auto-scroll al siguiente .cfg-step cuando se selecciona y se alcanza el max.
     Skip si layout=guiado (lo maneja pack-stepwise.js con scroll horizontal). */
  function maybeAutoAdvance(stepId, step, wasDeselection) {
    if (!root || root.dataset.cfgLayout === 'guiado') return;
    if (wasDeselection) return;
    if (step.max !== 1) return;
    const sel = STATE.selections[stepId] || [];
    if (sel.length < step.max) return;
    setTimeout(() => {
      if (!mount) return;
      const allSteps = Array.from(mount.querySelectorAll('.cfg-step'));
      let currentEl = null;
      for (const s of allSteps) {
        if (s.dataset.step === stepId) { currentEl = s; break; }
      }
      if (!currentEl) return;
      const idx = allSteps.indexOf(currentEl);
      const next = allSteps[idx + 1];
      if (next) {
        next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        const summary = mount.querySelector('.cfg-summary');
        if (summary) summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 450);
  }

  async function handleAddToCart(btn) {
    const pack = getPack(STATE.pack);
    if (!pack || !allMinsMet(pack) || pack.disabled) return;
    if (!pack.variant_id || pack.variant_id === 0) {
      alert('No se encuentra la variante del producto Pack ' + pack.name + '. Verifica el producto en admin.');
      return;
    }

    const properties = {};
    const refLines = []; // referencias variant_id para preparación de pedido
    for (const step of pack.steps) {
      const sel = STATE.selections[step.id] || [];
      if (sel.length === 0) continue;
      const labels = sel.map(h => {
        const p = step.products.find(prod => prod.handle === h);
        if (!p) return h;
        const label = fullVariantLabel(p);
        if (p.variant_id) {
          refLines.push(`${(step.title || '').replace(/<\/?em>/g, '')}: ${label} [variant ${p.variant_id}]`);
        }
        return label + (p.surcharge > 0 ? ` (+${formatPrice(p.surcharge)})` : '');
      });
      properties[(step.title || '').replace(/<\/?em>/g, '')] = labels.join(' · ');
    }
    properties['_pack_id'] = pack.handle + '-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7);
    properties['_pack_name'] = pack.name;
    if (refLines.length) properties['_pack_refs'] = refLines.join(' | ');

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Añadiendo...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: pack.variant_id, quantity: 1, properties: properties }],
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || ('HTTP ' + res.status));

      console.log('[PackConfigurator] Added to cart:', data);
      btn.textContent = 'Añadido. Yendo al carrito...';
      setTimeout(() => { window.location.href = '/cart'; }, 600);
    } catch (e) {
      console.error('[PackConfigurator] Add to cart error:', e);
      btn.disabled = false;
      btn.textContent = originalText;
      alert('No se pudo añadir al carrito.\n\n' + e.message);
    }
  }

  function renderMount() {
    if (!mount) return;
    if (!STATE.pack) { mount.innerHTML = ''; return; }
    const pack = getPack(STATE.pack);
    if (!pack) { mount.innerHTML = ''; return; }
    mount.innerHTML = renderActiveBlock(pack);
    /* Re-escanear reveals tras inyectar steps */
    if (typeof window.cfgRevealRescan === 'function') {
      requestAnimationFrame(() => window.cfgRevealRescan());
    }
  }

  /* Event delegation · 1 listener al root, persiste entre renders */
  function bindDelegatedEvents() {
    if (root._cfgBound) return;
    root._cfgBound = true;
    root.addEventListener('click', e => {
      // Botón info (i) en una card · prioridad sobre la propia card
      const infoBtn = e.target.closest('[data-info-handle]');
      if (infoBtn) {
        e.preventDefault();
        e.stopPropagation();
        openInfo(infoBtn.dataset.infoStep, infoBtn.dataset.infoHandle);
        return;
      }
      const card = e.target.closest('.cfg-product');
      if (card && card.dataset.step && card.dataset.handle) {
        e.preventDefault();
        toggleProduct(card.dataset.step, card.dataset.handle);
        return;
      }
      const addBtn = e.target.closest('[data-cfg-add]');
      if (addBtn) {
        e.preventDefault();
        handleAddToCart(addBtn);
        return;
      }
      const addBtnMobile = e.target.closest('[data-cfg-mbar-add]');
      if (addBtnMobile) {
        e.preventDefault();
        handleAddToCart(addBtnMobile);
        return;
      }
    });
  }

  /* ============ Init ============ */
  packBtns.forEach(btn => btn.addEventListener('click', () => setPack(btn.dataset.pack)));
  bindDelegatedEvents();

  /* Auto-cargar pack si la sección lo indica (caso producto) */
  if (autoloadHandle && getPack(autoloadHandle)) {
    setPack(autoloadHandle, { silent: true });
  }

  console.log('[PackConfigurator] Ready · ' + (DATA.packs || []).length + ' packs:',
    (DATA.packs || []).map(p => p.handle).join(', '),
    autoloadHandle ? `· autoload: ${autoloadHandle}` : '');
})();
